import { _ as _asyncToGenerator, a as _regeneratorRuntime } from './asyncToGenerator-c002e3ca.esm.js';
import { d as _defineProperty, c as _createClass, b as _classCallCheck } from './createClass-3115abc1.esm.js';
import { failure } from '@lens-protocol/shared-kernel';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

var CollectType;
(function (CollectType) {
  CollectType[CollectType["FREE"] = 0] = "FREE";
  CollectType[CollectType["PAID"] = 1] = "PAID";
})(CollectType || (CollectType = {}));
function isPaidCollectRequest(request) {
  return request.type === CollectType.PAID;
}
var CollectPublication = /*#__PURE__*/function () {
  function CollectPublication(tokenAvailability, signedFlow, signlessFlow, collectPublicationPresenter) {
    _classCallCheck(this, CollectPublication);
    this.tokenAvailability = tokenAvailability;
    this.signedFlow = signedFlow;
    this.signlessFlow = signlessFlow;
    this.collectPublicationPresenter = collectPublicationPresenter;
  }
  _createClass(CollectPublication, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isPaidCollectRequest(request)) {
                _context.next = 10;
                break;
              }
              _context.next = 3;
              return this.tokenAvailability.checkAvailability({
                amount: request.fee.amount,
                spender: request.fee.contractAddress
              });
            case 3:
              result = _context.sent;
              if (!result.isFailure()) {
                _context.next = 7;
                break;
              }
              this.collectPublicationPresenter.present(failure(result.error));
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return this.signedFlow.execute(request);
            case 9:
              return _context.abrupt("return");
            case 10:
              _context.next = 12;
              return this.signlessFlow.execute(request);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
  return CollectPublication;
}();

var ReferencePolicyType;
(function (ReferencePolicyType) {
  ReferencePolicyType["UNKNOWN"] = "UNKNOWN";
  ReferencePolicyType["DEGREES_OF_SEPARATION"] = "DEGREES_OF_SEPARATION";
  ReferencePolicyType["FOLLOWERS_ONLY"] = "FOLLOWERS_ONLY";
  ReferencePolicyType["ANYONE"] = "ANYONE";
})(ReferencePolicyType || (ReferencePolicyType = {}));

var ImageType;
(function (ImageType) {
  ImageType["JPEG"] = "image/jpeg";
  ImageType["PNG"] = "image/png";
  ImageType["WEBP"] = "image/webp";
  ImageType["GIF"] = "image/gif";
})(ImageType || (ImageType = {}));
var VideoType;
(function (VideoType) {
  VideoType["MP4"] = "video/mp4";
})(VideoType || (VideoType = {}));
var AudioType;
(function (AudioType) {
  AudioType["WAV"] = "audio/wav";
  AudioType["MP3"] = "audio/mpeg";
  AudioType["OGG"] = "audio/ogg";
})(AudioType || (AudioType = {}));
var SupportedFileType = _objectSpread2(_objectSpread2(_objectSpread2({}, ImageType), VideoType), AudioType);

var ContentFocus;
(function (ContentFocus) {
  ContentFocus["TEXT"] = "TextOnly";
  ContentFocus["IMAGE"] = "Image";
  ContentFocus["VIDEO"] = "Video";
  ContentFocus["AUDIO"] = "Audio";
  ContentFocus["ARTICLE"] = "Article";
})(ContentFocus || (ContentFocus = {}));
var NftAttributeDisplayType;
(function (NftAttributeDisplayType) {
  NftAttributeDisplayType["Number"] = "Number";
  NftAttributeDisplayType["String"] = "String";
  NftAttributeDisplayType["Date"] = "Date";
})(NftAttributeDisplayType || (NftAttributeDisplayType = {}));
var CollectPolicyType;
(function (CollectPolicyType) {
  CollectPolicyType["CHARGE"] = "CHARGE";
  CollectPolicyType["FREE"] = "FREE";
  CollectPolicyType["NO_COLLECT"] = "NO_COLLECT";
})(CollectPolicyType || (CollectPolicyType = {}));

export { AudioType as A, ContentFocus as C, ImageType as I, NftAttributeDisplayType as N, ReferencePolicyType as R, SupportedFileType as S, VideoType as V, _objectSpread2 as _, CollectPolicyType as a, CollectType as b, CollectPublication as c, isPaidCollectRequest as i };
